import React from 'react';
import { VersionLabel } from '../../../utils/enums';

interface PolicyStatusLabelProps {
  label: VersionLabel;
  versionNumber?: number;
}

const PolicyStatusLabel: React.FC<PolicyStatusLabelProps> = ({ label, versionNumber }) => {
  // Show version number only if label is Inactive and versionNumber is provided
  const showVersion = label === VersionLabel.Inactive && versionNumber !== undefined;
  const text = showVersion ? `${label} V${versionNumber}` : `${label}`;
  return (
    <span className={`policy-status-display ${label?.toLowerCase()}`}>
      {text}
    </span>
  );
};

export default PolicyStatusLabel;
export type { PolicyStatusLabelProps };
